"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Hammer, Paintbrush, Droplets, Trees, House, Wrench } from "lucide-react";
export default function OurServices() {
  const {
    ref: sectionRef,
    isVisible: sectionVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.1
  });
  const services = [{
    id: 1,
    icon: Hammer,
    title: "Remodeling",
    description: "Transform your space with our expert remodeling services, from kitchens to entire home makeovers."
  }, {
    id: 2,
    icon: House,
    title: "Construction",
    description: "Quality construction solutions for residential and commercial projects, built to last."
  }, {
    id: 3,
    icon: Trees,
    title: "Landscaping",
    description: "Enhance your outdoor spaces with professional landscaping design and maintenance."
  }, {
    id: 4,
    icon: Paintbrush,
    title: "Painting",
    description: "Interior and exterior painting services that bring new life to your property."
  }, {
    id: 5,
    icon: Droplets,
    title: "Powerwashing",
    description: "Deep cleaning services to restore surfaces and boost curb appeal."
  }, {
    id: 6,
    icon: Wrench,
    title: "Household Projects",
    description: "From repairs to installations, we handle all your household project needs."
  }];
  return <section id="our-services" ref={sectionRef} className="py-24 bg-light-background">
      <div className="container mx-auto px-4 max-w-7xl">
        <h2 className="text-4xl font-bold text-center text-foreground mb-16">
          Our Services
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, i) => {
          const Icon = service.icon;
          return <Card key={service.id} data-index={i} className={`border border-muted shadow-soft hover:shadow-medium transition-all duration-[150ms] ease-out ${sectionVisible ? "animate-fade-in-up" : "opacity-0"}`} style={{
            animationDelay: sectionVisible ? `${i * 100}ms` : "0ms"
          }}>
                <CardHeader>
                  <div className="w-12 h-12 rounded-md bg-primary/10 flex items-center justify-center mb-4">
                    <Icon className="w-6 h-6 text-primary" />
                  </div>
                  <CardTitle className="text-xl text-foreground">
                    {service.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <CardDescription className="text-muted-foreground">
                    {service.description}
                  </CardDescription>
                </CardContent>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}